import React, { useEffect, useState } from "react";

import { ChainId, shortenIfAddress, useEthers } from "@usedapp/core";
import { Backdrop, Button, Modal } from "@mui/material";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { InjectedConnector } from "@web3-react/injected-connector";
import styled from "@emotion/styled";
import themes from "../../themes";
export const injected = new InjectedConnector({ supportedChainIds: [1, 4] });

export const WalletButton = ({ account }: { account?: string | null }) => {
  const { activate, activateBrowserWallet } = useEthers();
  const [open, setOpen] = useState(false);

  const rpc: any =
    process.env.REACT_APP_CHAIN_ID === "4"
      ? { 4: "https://rinkeby.infura.io/v3/8e4ccb97c95e44ff9af8164210709b44" }
      : { 1: "https://mainnet.infura.io/v3/8e4ccb97c95e44ff9af8164210709b44" };
  const walletConnectConnector = new WalletConnectConnector({
    rpc,
    supportedChainIds: [
      process.env.REACT_APP_CHAIN_ID === "4"
        ? ChainId.Rinkeby
        : ChainId.Mainnet,
    ],
  });

  useEffect(() => {
    injected.isAuthorized().then((isAuthorized) => {
      if (isAuthorized) {
        activate(injected);
      }
    });
  }, [activate]);

  return (
    <>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => {
          if (!account) {
            setOpen(true);
          } else {
            return;
          }
        }}
      >
        {!account ? "Connect Wallet" : shortenIfAddress(account)}
      </Button>
      <StyledModal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Content>
          <h2
            style={{
              textAlign: "center",
              fontSize: 18,
              marginBottom: 16,
              fontFamily: "'Press Start 2P', sans-serif",
            }}
            id="transition-modal-title"
          >
            Connect Wallet with
          </h2>
          <ButtonWrapper>
            <Button
              variant="outlined"
              onClick={() => {
                activateBrowserWallet();
                setOpen(false);
              }}
              style={{ marginRight: 8 }}
            >
              Metamask
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                activate(walletConnectConnector);
                setOpen(false);
              }}
            >
              WalletConnect
            </Button>
          </ButtonWrapper>
        </Content>
      </StyledModal>
    </>
  );
};

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  background-color: #000;
  color: #fff;
  border: 1px solid #fff;
  padding: 32px;
  z-index: 100;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  @media screen and (max-width: 420px) {
    display: block;
    & > button {
      width: 100%;
      margin-bottom: ${themes.spacing(1)};
    }
  }
`;
